<template>
  <div class="fixed-top border-b-red">
      <b-navbar toggleable="sm" type="light" variant="light">
        <div class="container">
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            <b-navbar-brand><a href="/"><img src="@/assets/img/logo-progresso.png" width="150" alt=""></a></b-navbar-brand>

            <b-collapse id="nav-collapse" is-nav class="justify-content-end">
              <b-navbar-nav id="navbar">
                  <b-nav-item href="#home" class="link">Home</b-nav-item>
                  <b-nav-item href="#about" class="link">About Us</b-nav-item>
                  <b-nav-item href="#services" class="link">Services</b-nav-item>
                  <b-nav-item href="#team" class="link">Team</b-nav-item>
                  <b-nav-item href="#credentials" class="link">Our Credentials</b-nav-item>
                  <!--<b-nav-item href="#contact" class="link">Contact</b-nav-item>-->
              </b-navbar-nav>
            </b-collapse>
        </div>
    </b-navbar>
  </div>

</template>

<script>
export default {
    name: 'Header',
    data() {
      return {
        isActive: false
      }
    },
    methods: {

    },
}
</script>

<style>

</style>